import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Badge, Card, Row, Col, Container, Spinner, Accordion, InputGroup, Alert } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';

const usuario = localStorage.getItem("chapa");

function CentralDuvidasRH() {
    const [chamados, setChamados] = useState([]);
    const [assuntos, setAssuntos] = useState([]);
    const [mensagens, setMensagens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const [showNovo, setShowNovo] = useState(false);
    const [idAssunto, setIdAssunto] = useState("");
    const [textoAssunto, setTextoAssunto] = useState("");
    const [faqSugestao, setFaqSugestao] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [arquivo, setArquivo] = useState(null);

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [showFAQ, setShowFAQ] = useState(false);
    const [filtroFAQ, setFiltroFAQ] = useState("");
    const [selected, setSelected] = useState(null);
    const [escrevendoReplicado, setEscrevendoReplicado] = useState(false);
    const [mensagemReplicado, setMensagemReplicado] = useState("");
    const [arquivoReplicado, setArquivoReplicado] = useState(null);

    // =========================================================
    // PREVIEW DE ANEXO
    // =========================================================
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewTipo, setPreviewTipo] = useState(null);
    const [previewNome, setPreviewNome] = useState(null);

    const fecharPreview = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setPreviewUrl(null);
        setPreviewTipo(null);
        setPreviewNome(null);
        setShowPreview(false);
    };

    const formatarDataHora = (isoString) => {
        if (!isoString) return "";

        const data = isoString.replace("Z", "");
        const dt = new Date(data);

        const dia = String(dt.getDate()).padStart(2, "0");
        const mes = String(dt.getMonth() + 1).padStart(2, "0");
        const ano = dt.getFullYear();
        const hora = String(dt.getHours()).padStart(2, "0");
        const minuto = String(dt.getMinutes()).padStart(2, "0");
        const segundo = String(dt.getSeconds()).padStart(2, "0");

        return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
    };

    // =========================================================

    // =========================================================
    // BASE64
    // =========================================================
    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) {
            console.error("Erro ao codificar Base64:", e);
            return "";
        }
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const pad = base64.length % 4;
            if (pad !== 0) base64 += "=".repeat(4 - pad);
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        } catch (e) {
            console.error("Erro ao decodificar Base64:", e, str);
            return str;
        }
    };
    // =========================================================

    useEffect(() => {
        loadChamados();
        loadAssuntos();
    }, []);


    const handleSelectAssunto = (id) => {
        setIdAssunto(id);
        const assuntoEncontrado = assuntos.find(a => String(a.ID_ASSUNTO || a.id_assunto) === String(id));
        if (assuntoEncontrado) {
            setTextoAssunto(assuntoEncontrado.DESCRICAO_ASSUNTO || assuntoEncontrado.descricao_assunto);
            setFaqSugestao(decodeBase64(decodeBase64(assuntoEncontrado.TEXTO_FAQ_ASSUNTO || assuntoEncontrado.texto_faq_assunto)));
        } else {
            setTextoAssunto("");
            setFaqSugestao("");
        }
    };

    // =========================================================
    // BUSCAR E ABRIR ARQUIVO COM PREVIEW EM MODAL
    // =========================================================
    // BUSCAR E ABRIR ARQUIVO COM PREVIEW NO MODAL
    // =========================================================
    const handleBuscarEVerArquivo = async (idChamado, idInteracao, nomeArquivo) => {
        try {
            setLoading(true);

            const response = await api.get(
                `/rh/chamado/${idChamado}/arquivo?id_interacao=${idInteracao}`
            );

            const dados = response.data;
            const base64Dados =
                (Array.isArray(dados) && dados.length > 0 &&
                    (dados[0].anexo_blob ||
                        dados[0].ANEXO_BLOB ||
                        dados[0].anexo_base64 ||
                        dados[0].ANEXO_BASE64)) ||
                dados?.anexo_blob ||
                dados?.ANEXO_BLOB ||
                dados?.anexo_base64 ||
                dados?.ANEXO_BASE64 ||
                dados; // fallback caso venha direto como string

            if (!base64Dados) {
                Swal.fire("Aviso", "Arquivo não encontrado no servidor.", "warning");
                return;
            }

            abrirPreviewArquivo(base64Dados, nomeArquivo);
        } catch (err) {
            console.error("Erro ao buscar arquivo:", err);
            Swal.fire("Erro", "Falha ao recuperar o anexo.", "error");
        } finally {
            setLoading(false);
        }
    };

    const abrirPreviewArquivo = (base64, nomeArquivo) => {
        try {
            const base64Limpo = base64
                .replace(/^data:.*;base64,/, "")
                .replace(/\r?\n|\r/g, "")
                .trim();

            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            let type = "application/octet-stream";
            const ext = (nomeArquivo || "").toLowerCase();
            if (ext.endsWith(".pdf")) type = "application/pdf";
            else if (ext.endsWith(".png")) type = "image/png";
            else if (ext.endsWith(".jpg") || ext.endsWith(".jpeg")) type = "image/jpeg";

            const blob = new Blob([byteArray], { type });
            const url = URL.createObjectURL(blob);

            setPreviewUrl(url);
            setPreviewTipo(type);
            setPreviewNome(nomeArquivo || "arquivo");
            setShowPreview(true);
        } catch (err) {
            console.error("Erro ao abrir arquivo:", err);
            Swal.fire("Erro", "Falha ao abrir o arquivo.", "error");
        }
    };

    // =========================================================

    const renderPreviewConteudo = () => {
        if (!previewUrl || !previewTipo) return null;

        if (previewTipo.includes("pdf")) {
            return (
                <iframe
                    src={previewUrl}
                    title="Preview PDF"
                    style={{ width: "100%", height: "80vh", border: "none" }}
                />
            );
        }

        if (previewTipo.startsWith("image/")) {
            return (
                <img
                    src={previewUrl}
                    alt={previewNome || "Preview"}
                    style={{ maxWidth: "100%", maxHeight: "80vh", display: "block", margin: "0 auto" }}
                />
            );
        }

        return (
            <div className="text-center p-4">
                <p>Este tipo de arquivo não pode ser visualizado diretamente.</p>
                <Button
                    variant="primary"
                    onClick={() => {
                        const link = document.createElement("a");
                        link.href = previewUrl;
                        link.download = previewNome || "arquivo";
                        link.click();
                    }}
                >
                    Baixar arquivo
                </Button>
            </div>
        );
    };

    const loadChamados = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/rh/chamados/${usuario}`);
            setChamados(response.data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    const loadAssuntos = async () => {
        try {
            const response = await api.get('/rh/assuntos');
            setAssuntos(response.data);
        } catch (err) { console.error(err); }
    };

    const handleAbrirDetalhes = async (chamado) => {
        setSelected(chamado);
        setEscrevendoReplicado(false);
        setMensagemReplicado("");
        setArquivoReplicado(null);
        setLoadingDetalhes(true);
        try {
            const response = await api.get(`/rh/chamado/${chamado.id_chamado || chamado.ID_CHAMADO}/interacoes`);
            setMensagens(response.data || []);
            setShowDetalhes(true);
        } catch (err) {
            Swal.fire('Erro', 'Não foi possível carregar o histórico.', 'error');
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const handleSalvar = async () => {
        const textoPuro = mensagem.replace(/<(.|\n)*?>/g, '').trim();
        if (!textoAssunto.trim() || !textoPuro) return Swal.fire('Atenção', 'Preencha o assunto e a dúvida!', 'warning');

        setLoading(true);
        try {
            let arquivoBase64 = "";
            let nomeArquivo = "";

            if (arquivo) {
                const reader = new FileReader();
                arquivoBase64 = await new Promise((resolve) => {
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.readAsDataURL(arquivo);
                });
                nomeArquivo = arquivo.name;
            }

            await api.post('/rh/chamado', {
                chapa: usuario,
                id_assunto: idAssunto ? parseInt(idAssunto) : null,
                descricao_assunto_manual: textoAssunto,
                assunto_custom: textoAssunto,
                mensagem: encodeBase64(mensagem),
                anexo_base64: arquivoBase64,
                nome_arquivo: nomeArquivo
            });

            Swal.fire('Sucesso', 'Dúvida enviada!', 'success');
            setShowNovo(false);
            setMensagem(""); setArquivo(null); setIdAssunto(""); setTextoAssunto(""); setFaqSugestao("");
            loadChamados();
        } catch (err) { Swal.fire('Erro', 'Falha ao enviar.', 'error'); }
        finally { setLoading(false); }
    };

    const handleFinalizar = async () => {
        try {
            await api.put(`/rh/chamado/finalizar/${selected.id_chamado || selected.ID_CHAMADO}`, {
                chapa: usuario,
                mensagem: encodeBase64("Chamado finalizado com sucesso pelo colaborador")
            });
            Swal.fire('Sucesso', 'Atendimento finalizado!', 'success');
            setShowDetalhes(false);
            loadChamados();
        } catch (err) { Swal.fire('Erro', 'Falha ao finalizar.', 'error'); }
    };

    const handleNaoConcordo = async () => {
        const textoPuro = mensagemReplicado.replace(/<(.|\n)*?>/g, "").trim();
        if (!textoPuro) {
            Swal.fire("Atenção", "Explique sua dúvida.", "warning");
            return;
        }

        try {
            let arquivoBase64 = "";
            let nomeArquivo = "";

            if (arquivoReplicado) {
                const reader = new FileReader();
                arquivoBase64 = await new Promise((resolve) => {
                    reader.onloadend = () => resolve(reader.result.split(",")[1]);
                    reader.readAsDataURL(arquivoReplicado);
                });
                nomeArquivo = arquivoReplicado.name;
            }

            await api.put(`/rh/chamado/transferir/${selected.id_chamado || selected.ID_CHAMADO}`, {
                chapa: usuario,
                mensagem: encodeBase64(mensagemReplicado),
                arquivo: arquivoBase64,
                nome_arquivo: nomeArquivo,
            });

            Swal.fire("Enviado", "Sua réplica foi enviada ao RH.", "success");
            setShowDetalhes(false);
            loadChamados();
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Falha ao transferir.", "error");
        }
    };


    const renderBadgeStatus = (status) => {
        const s = parseInt(status);
        switch (s) {
            case 0: return <Badge bg="warning" text="dark">AGUARDANDO RH</Badge>;
            case 1: return <Badge bg="info">RESPONDIDO (AUTO)</Badge>;
            case 2: return <Badge bg="success">RESPONDIDO</Badge>;
            case 3: return <Badge bg="secondary">FINALIZADO</Badge>;
            default: return <Badge bg="light" text="dark">N/A</Badge>;
        }
    };

    const faqsFiltrados = assuntos.filter(a =>
        (a.DESCRICAO_ASSUNTO || a.descricao_assunto || "").toLowerCase().includes(filtroFAQ.toLowerCase())
    );

    return (
        <div className="d-flex flex-column" style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
            <Menu modulo="ARBOR" />

            <Container className="flex-grow-1 py-5 mt-5 mb-4">
                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <div className="d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm mb-4">
                            <h5 className="text-primary fw-bold mb-0">💬 Central de Dúvidas RH</h5>
                            <div className="d-flex gap-2">
                                <Button variant="outline-primary" size="sm" onClick={() => setShowFAQ(true)}>
                                    <i className="bi bi-search me-1"></i> Ver FAQs
                                </Button>
                                <Button variant="primary" size="sm" onClick={() => setShowNovo(true)}>+ Nova Dúvida</Button>
                            </div>
                        </div>

                        <div className="custom-scroll" style={{ maxHeight: 'calc(100vh - 320px)', overflowY: 'auto', position: 'relative' }}>
                            {loading && <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>}

                            {!loading && chamados.map(item => {
                                const status = item.status_chamado ?? item.STATUS_CHAMADO;
                                return (
                                    <Card key={item.id_chamado || item.ID_CHAMADO} className="border-0 shadow-sm mb-2 card-item" onClick={() => handleAbrirDetalhes(item)}>
                                        <Card.Body className="p-3">
                                            <Row className="align-items-center">
                                                <Col xs={10}>
                                                    <div className="mb-2">{renderBadgeStatus(status)}</div>
                                                    <h6 className="fw-bold mb-1">{item.descricao_assunto || item.DESCRICAO_ASSUNTO || item.ASSUNTO_CUSTOM}</h6>
                                                    <div className="text-muted small mb-0 text-truncate"
                                                        dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(item.pergunta_chamado || item.PERGUNTA_CHAMADO)) }} />
                                                    <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                        <i className="bi bi-clock me-1"></i>
                                                        {formatarDataHora(item.ultimainteracao)}
                                                    </small>
                                                </Col>
                                                <Col xs={2} className="text-end"><i className="bi bi-chevron-right text-muted"></i></Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Modal de Detalhes / Chat */}
            <Modal show={showDetalhes} onHide={() => setShowDetalhes(false)} centered size="lg">
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fs-6 fw-bold">Atendimento #{selected?.id_chamado || selected?.ID_CHAMADO}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-chat p-4" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <div className="d-flex flex-column">
                        {mensagens.map((msg, idx) => {
                            const autor = String(msg.TIPO_AUTOR || msg.tipo_autor || msg.ORIGEM || msg.origem || "").toUpperCase();
                            const dataHora = msg.datahora_interacao || msg.DATAHORA_INTERACAO || msg.data_interacao || msg.DATA_CADASTRO;
                            const temAnexo =
                                msg.tem_anexo === "S" ||
                                msg.TEM_ANEXO === "S";

                            return (
                                <div key={idx} className={`balao-container ${autor === 'U' ? 'user' : 'rh'}`}>
                                    <div className="balao shadow-sm">
                                        <small className={`d-block border-bottom mb-1 fw-bold ${autor === 'U' ? '' : 'text-success'}`}>
                                            {autor === 'U' ? 'VOCÊ:' : 'RH:'}
                                        </small>

                                        <div className="small" dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(msg.MENSAGEM || msg.mensagem)) }} />

                                        {temAnexo && (
                                            <div className={`mt-2 pt-2 border-top ${autor === 'U' ? 'border-white-50' : 'border-secondary-subtle'}`}>
                                                <Button
                                                    variant={autor === 'U' ? "outline-success" : "outline-primary"}
                                                    size="sm"
                                                    className="d-flex align-items-center gap-2"
                                                    onClick={() => handleBuscarEVerArquivo(
                                                        selected?.id_chamado || selected?.ID_CHAMADO,
                                                        msg.id_interacao || msg.ID_INTERACAO,
                                                        msg.anexo_nome || msg.ANEXO_NOME || "arquivo"
                                                    )}
                                                >
                                                    <i className="bi bi-paperclip"></i>
                                                    Visualizar Arquivo
                                                </Button>
                                            </div>
                                        )}

                                        <div className="text-end mt-1" style={{ fontSize: '0.65rem', opacity: 0.7 }}>
                                            {formatarDataHora(dataHora)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        {["1", "2"].includes(String(selected?.status_chamado ?? selected?.STATUS_CHAMADO)) && !escrevendoReplicado && (
                            <div className="mt-4 p-3 bg-white rounded shadow-sm border text-center">
                                <p className="small fw-bold text-muted mb-3">O RH respondeu. Como deseja prosseguir?</p>
                                <div className="d-flex gap-2">
                                    <Button variant="success" className="w-100 fw-bold" onClick={handleFinalizar}>RETORNO SATISFATÓRIO</Button>
                                    <Button variant="outline-danger" className="w-100 fw-bold" onClick={() => setEscrevendoReplicado(true)}>NÃO ESTOU DE ACORDO</Button>
                                </div>
                            </div>
                        )}

                        {escrevendoReplicado && (
                            <div className="mt-3 bg-white p-3 rounded shadow-sm border">
                                <Form.Label className="small fw-bold text-danger">Descreva o motivo da sua réplica:</Form.Label>
                                <ReactQuill theme="snow" value={mensagemReplicado} onChange={setMensagemReplicado} />

                                <Form.Group className="mt-2">
                                    <Form.Label className="small fw-bold">Anexar arquivo (opcional)</Form.Label>
                                    <Form.Control
                                        type="file"
                                        size="sm"
                                        accept="image/*,.pdf"
                                        onChange={(e) => setArquivoReplicado(e.target.files[0])}
                                    />
                                </Form.Group>

                                <div className="d-flex gap-2 mt-2">
                                    <Button variant="primary" size="sm" onClick={handleNaoConcordo}>Enviar Réplica</Button>
                                    <Button variant="link" size="sm" className="text-muted" onClick={() => setEscrevendoReplicado(false)}>Cancelar</Button>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer><Button variant="secondary" size="sm" onClick={() => setShowDetalhes(false)}>Fechar</Button></Modal.Footer>
            </Modal>

            {/* Modal de Nova Dúvida */}
            <Modal show={showNovo} onHide={() => setShowNovo(false)} centered size="lg">
                <Modal.Header closeButton><Modal.Title className="fs-6 fw-bold">Nova Dúvida</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Selecione um Assunto</Form.Label>
                        <Form.Select value={idAssunto} onChange={e => handleSelectAssunto(e.target.value)}>
                            <option value="">Outro / Assunto não listado</option>
                            {assuntos.map(a => <option key={a.ID_ASSUNTO || a.id_assunto} value={a.ID_ASSUNTO || a.id_assunto}>{a.DESCRICAO_ASSUNTO || a.descricao_assunto}</option>)}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Título do Assunto</Form.Label>
                        <Form.Control type="text" placeholder="Ex: Erro no meu contracheque" value={textoAssunto} onChange={e => setTextoAssunto(e.target.value)} />
                    </Form.Group>

                    {faqSugestao && (
                        <Alert variant="info" className="py-2 shadow-sm border-start border-info border-4">
                            <h6 className="fw-bold mb-1" style={{ fontSize: '0.85rem' }}>
                                <i className="bi bi-info-circle me-2"></i>Dica do RH (FAQ):
                            </h6>
                            <div style={{ fontSize: '0.8rem' }} dangerouslySetInnerHTML={{ __html: faqSugestao }} />
                        </Alert>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Sua dúvida detalhada</Form.Label>
                        <ReactQuill theme="snow" value={mensagem} onChange={setMensagem} />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label className="small fw-bold">Anexar Arquivo (Opcional)</Form.Label>
                        <Form.Control type="file" size="sm" onChange={(e) => setArquivo(e.target.files[0])} accept="image/*,.pdf" />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer><Button variant="primary" className="w-100 fw-bold" onClick={handleSalvar} disabled={loading}>Enviar ao RH</Button></Modal.Footer>
            </Modal>

            {/* Modal de FAQs */}
            <Modal show={showFAQ} onHide={() => setShowFAQ(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fs-6 fw-bold">Perguntas Frequentes (FAQs)</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
                        <Form.Control placeholder="Pesquisar em FAQs..." value={filtroFAQ} onChange={e => setFiltroFAQ(e.target.value)} />
                    </InputGroup>
                    <Accordion>
                        {faqsFiltrados.map((faq, idx) => (
                            <Accordion.Item eventKey={String(idx)} key={idx}>
                                <Accordion.Header>
                                    <span className="fw-bold" style={{ fontSize: '0.9rem' }}>
                                        {faq.DESCRICAO_ASSUNTO || faq.descricao_assunto}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body style={{ fontSize: '0.85rem', backgroundColor: '#f8f9fa' }}>
                                    <div dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(faq.TEXTO_FAQ_ASSUNTO || faq.texto_faq_assunto)) }} />
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowFAQ(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Preview de Anexo */}
            <Modal show={showPreview} onHide={fecharPreview} size="xl" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Preview: {previewNome}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderPreviewConteudo()}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharPreview}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            <Footer />

            <style>{`
                .bg-chat { background-color: #e5ddd5; }
                .balao-container { display: flex; margin-bottom: 12px; width: 100%; }
                .balao-container.user { justify-content: flex-end; }
                .balao-container.rh { justify-content: flex-start; }
                .balao { padding: 10px 14px; border-radius: 12px; max-width: 85%; font-size: 0.88rem; min-width: 140px; position: relative; }
                .user .balao { background-color: #dcf8c6; border-top-right-radius: 0; }
                .rh .balao { background-color: #ffffff; border-top-left-radius: 0; }
                .card-item { cursor: pointer; transition: 0.2s; border-left: 5px solid #007bff !important; }
                .card-item:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important; }
                .ql-container { background: white; min-height: 100px; }
            `}</style>

            <style>{`
                .ql-container.ql-snow {
                    color: #000000 !important;
                    background-color: #ffffff !important;
                }

                .ql-editor, .ql-editor * {
                    color: #000000 !important;
                    -webkit-text-fill-color: #000000 !important;
                }

                .bg-chat-rh .small.text-break, 
                .bg-chat-rh .small.text-break * {
                    color: #212529 !important;
                }

                .card-rh-item { 
                    cursor: pointer; 
                    transition: 0.2s; 
                    border-left: 5px solid transparent; 
                }
                .card-rh-item:hover { 
                    border-left: 5px solid #0d6efd; 
                    background-color: #fff; 
                    transform: translateY(-2px); 
                }
                
                .bg-chat-rh { 
                    background-color: #f8f9fa; 
                    max-height: 60vh; 
                }

                .ql-container { 
                    min-height: 150px; 
                    border-bottom-left-radius: 5px; 
                    border-bottom-right-radius: 5px; 
                }

                .ql-toolbar { 
                    border-top-left-radius: 5px; 
                    border-top-right-radius: 5px; 
                    background: #eee !important; 
                }

                .x-small { 
                    font-size: 0.72rem; 
                    font-weight: bold; 
                    text-transform: uppercase; 
                }
            `}</style>
        </div>
    );
}

export default CentralDuvidasRH;
